<template>
  <PlatformViVT2
    ref="platform"
    :bridge="bridge"
    :localStoragePrefix="localStoragePrefix"
    :buttons="buttons"
    :outputs="outputs"
    :leds="leds"
    :uarts="uarts"
    :languages="languages"
    :vbusSpecifications="vbusSpecifications"
    @initialized="platformInitialized"
  ></PlatformViVT2>
</template>

<script>
import { BasicPlatformWasiBridge } from '@/bridges/BasicPlatformWasiBridge';

import PlatformViVT2 from '@/device-platforms/PlatformViVT2.vue';

export default {
  props: [
    'localStoragePrefix',
  ],

  components: {
    PlatformViVT2,
  },

  data: () => ({
    label: 'Viessmann Vitotrans 353 2017 - 2.0',
    wasmUrl:'/Viessmann_Vitotrans_353_VT2.wasm',
    wasmModule: null,
    bridge: null,
    vbusSpecifications: [],

    buttons: [
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 70.3, name: 'S1', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 35.3, name: 'S2', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 20.3, name: 'S3', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 20.3, name: 'S4', },
      { conversion: 'resistorPt1000Temperature', value: null, initialValue: 20.3, name: 'S5', },
      { conversion: 'voltage', value: null, initialValue: 0.0, name: 'AIN-Huba', },
      { conversion: 'frequencyGrundfos_UPM4_Profile17', value: null, initialValue: 0.0, name: 'PWMIn1', },
      { conversion: 'frequencyGrundfos_UPM4_Profile17', value: null, initialValue: 0.0, name: 'PWMIn2', },
      { conversion: 'frequencyHuba_200_9110xxNFlow', value: null, initialValue: 0.0, name: 'DN10', },
    ],
    outputs: [
      { name: 'R1', conversion: 'dutycyclePercent', value: null },
      { name: 'R2', conversion: 'dutycyclePercent', value: null },
      { name: 'R3', conversion: 'dutycyclePercent', value: null },
      { name: 'R4', conversion: 'dutycyclePercent', value: null },
      { name: 'R5', conversion: 'dutycyclePercent', value: null }, // Nach Plattformumstellung auch digitalPercent
      { name: 'RPF', conversion: 'rawDigital', value: null },
      { name: 'PWM1', conversion: 'dutycyclePercent', value: null },
      { name: 'PWM2', conversion: 'dutycyclePercent', value: null },
    ],

    leds: [
        { state: null }
    ],

    uarts: [
      { name: 'UART0', kind: 'VBus', },
      { name: 'UART1', kind: 'VBus', },
    ],

    languages: [
      { value: 0, text: 'Deutsch', short: 'de' },
      { value: 1, text: 'Bulgarisch', short: 'bg' },
      { value: 2, text: 'Tschechisch', short: 'cz' },
      { value: 3, text: 'Dänisch', short: 'dk' },
      { value: 4, text: 'Englisch', short: 'en' },
      { value: 5, text: 'Spanisch', short: 'sp' },
      { value: 6, text: 'Estnisch', short: 'ee' },
      { value: 7, text: 'Französisch', short: 'fr' },
      { value: 8, text: 'Kroatisch', short: 'hr' },
      { value: 9, text: 'Italienisch', short: 'it' },
      { value: 10, text: 'Lettisch', short: 'lv' },
      { value: 11, text: 'Litauisch', short: 'lt' },
      { value: 12, text: 'Ungarisch', short: 'hu' },
      { value: 13, text: 'Niederländisch', short: 'nl' },
      { value: 14, text: 'Polnisch', short: 'pl' },
      { value: 15, text: 'Russisch', short: 'ru' },
      { value: 16, text: 'Rumänisch', short: 'ro' },
      { value: 17, text: 'Slowenisch', short: 'sl' },
      { value: 18, text: 'Finnisch', short: 'fi' },
      { value: 19, text: 'Schwedish', short: 'sv' },
      { value: 20, text: 'Portugiesisch', short: 'pt' },
      { value: 21, text: 'Türkisch', short: 'tr' },
      { value: 22, text: 'Serbisch', short: 'sr' },
      { value: 23, text: 'Slowakisch', short: 'sk' },
      { value: 24, text: 'Chinesisch', short: 'zh' },
    ],
  }),

  mounted() {
  },

  methods: {
    async prepareDevice() {
      const response = await fetch(this.wasmUrl);
      const wasmArrayBuffer = await response.arrayBuffer();
      this.wasmModule = await WebAssembly.compile(wasmArrayBuffer);
      this.bridge = new BasicPlatformWasiBridge(this.wasmModule);
      await this.bridge.instantiate();

      this.$refs.platform.prepareBridgeable();
    },

    startDevice() {
      this.bridge.start();
    },

    restartDevice() {},

    platformInitialized() {
    },
  },
};
</script>

<style>

</style>
